import { api } from '../api';
import { provider, tags } from '../tags';
import type { EmailValidateToken, EmailVerification } from '../types';

/* istanbul ignore file */

export const emailVerifyApi = api.injectEndpoints({
  overrideExisting: false,
  endpoints: (builder) => ({
    emailVerifications: builder.query<Array<EmailVerification>, void>({
      query: () => 'api/emailverify/',
      providesTags: provider<EmailVerification>(tags.emailVerification),
    }),

    emailVerify: builder.mutation<EmailVerification, EmailVerification>({
      query: (data) => ({
        url: data.id ? `api/emailverify/${data.id}/` : 'api/emailverify/',
        method: data.id ? 'PATCH' : 'POST',
        body: data,
      }),
      invalidatesTags: [tags.emailVerification],
    }),

    emailTokenValidation: builder.mutation<EmailValidateToken, EmailValidateToken>({
      query: (data) => ({
        url: `api/emailvalidatetoken/${data.id}/`,
        method: 'PATCH',
        body: data,
      }),
      invalidatesTags: [tags.emailVerification],
    }),
  }),
});
